export const ver = /* glsl */ `
varying highp vec2 vUv;
varying vec3 vWorldPosition;
varying vec3 vViewPosition;
varying vec3 vNormal;

#include <common>
#include <logdepthbuf_pars_vertex>

void main() {
  #include <begin_vertex>
  #include <project_vertex>
  #include <logdepthbuf_vertex>
  
  vUv = uv;
  vec4 worldPosition = modelMatrix * vec4(position, 1.0);
  vWorldPosition = worldPosition.xyz;
  gl_Position = projectionMatrix * viewMatrix * worldPosition;
  
  vNormal = normalize(mat3(transpose(inverse(modelMatrix))) * normal);
  vec3 cameraToVertex = normalize(cameraPosition - vWorldPosition);
  vViewPosition = cameraToVertex;
}
`

export const frag = /* glsl */ `
#include <logdepthbuf_pars_fragment>

uniform float progress;
uniform float addOpacity;
uniform float objSize;
uniform bool isFadeIn;
uniform vec3 center;

varying vec2 vUv;
varying vec3 vWorldPosition;
varying vec3 vNormal;
varying vec3 vViewPosition;

void main() {
  #include <logdepthbuf_fragment>

  if (isFadeIn) {
    vec3 myWorldPosition = vWorldPosition / objSize;
    vec3 viewDirection = normalize(vViewPosition);
    vec3 normal = normalize(vNormal);
    float lightIntensity = 1.0 - pow(dot(normal, viewDirection), 2.0);

    float circle1 = 0.5 - clamp(distance(center / objSize, myWorldPosition * 0.5), 0.0, 0.55);

    float circleOut = step(distance(center / objSize, myWorldPosition), progress);
    float circleIn = step(distance(center / objSize, myWorldPosition), progress - 0.002);
    float circleW = circleOut - circleIn;

    vec4 color = mix(vec4(1.0, 0.43, 0.0, 0.1), vec4(1.0, 0.43, 0.0, 1.0), circle1);
    gl_FragColor = color * lightIntensity * 0.8 + vec4(circleW * 20.0, circleW * 8.6, circleW * 0.0, circleW * 2.0);
    gl_FragColor.w *= circleOut * addOpacity;
    
  } else {
    vec3 myWorldPosition = vWorldPosition / objSize;
    vec3 viewDirection = normalize(vViewPosition);
    vec3 normal = normalize(vNormal);
    float lightIntensity = 1.0 - pow(dot(normal, viewDirection), 2.0);

    float circle1 = 0.5 - clamp(distance(center / objSize, myWorldPosition * 0.5), 0.0, 0.55);
    float circleOut = 1.0 - step(distance(center / objSize, myWorldPosition), progress);
    float circleIn = 1.0 - step(distance(center / objSize, myWorldPosition), progress - 0.002);
    float circleW = circleOut - circleIn;

    vec4 color = mix(vec4(1.0, 0.43, 0.0, 0.1), vec4(1.0, 0.43, 0.0, 1.0), circle1);
    gl_FragColor = color * lightIntensity * 0.8 + vec4(circleW * 20.0, circleW * 8.6, circleW * 0.0, circleW * 2.0);
    gl_FragColor.w *= circleIn * addOpacity;
  }
}
`
